import { Component, Input } from '@angular/core'
import { IonicModule } from '@ionic/angular'
import { NgIf } from '@angular/common'
import { LiveEvent } from '../../../../core/models/live-events'
import { getEventSrcImage, getLineSrcImage } from '../../live-event-view-model'

@Component({
  selector: 'app-icon-information',
  standalone: true,
  imports: [IonicModule, NgIf],
  template: `
    <div>
      <ion-icon *ngIf="eventSrcImage" class="small-size-icon ion-margin" [src]="eventSrcImage" />
      <ion-icon *ngIf="lineSrcImage" class="small-size-icon" [src]="lineSrcImage" />
    </div>
  `,
  styles: `
    ion-icon {
      margin: 0 3px;
    }
  `,
})
export class IconInformationComponent {
  @Input() event: LiveEvent

  get eventSrcImage() {
    return getEventSrcImage(this.event)
  }

  get lineSrcImage() {
    return getLineSrcImage(this.event)
  }
}
